import {
  ACCOUNT_TYPE,
  LOGIN_POSITIONS,
  BACKGROUND_TYPES,
  FILLING_TYPES,
  AUTHENTICATION_METHOD,
} from 'common/constants/Constants';

/**
 * 全局通用的类型
 * */
export enum PersonVerify {
  mobile = 'mobile',
  weChat = 'wechat',
}
// 确保 其第一级accountUser 、account、user 一定是对象
export interface IUserInfo {
  accountUser: {
    name: string;
    avatarUrl: string;
    isCreator: boolean;
    isSuperAdmin: boolean;
    isAdmin: boolean;
    loginBySso: boolean;
    unionId: string;
    units: string[];
    passwordInitialized: boolean;
    fuzzyMobile: string;
    mobile: string;
    emailAccount: string;
    isEmailPasswordSet: boolean;
  } | null;
  account: {
    accountId: string;
    accountType: ACCOUNT_TYPE;
    companyName: string;
    isVendor: boolean;
    logoUrl?: string;
  } | null;
  user: {
    fuzzyMobile: string;
    isCreator: boolean;
    isPasswordSet: boolean;
    isWeComBound: boolean;
    qq: string;
    weChat: string;
    personVerify?: PersonVerify[];
  } | null;
  authenticationMethod: AUTHENTICATION_METHOD | undefined;
}

export interface IAccount {
  domainId: string;
  logoUrl: string;
  mobile: string;
  name: string;
  sourceName: string;
  usernameStatus: string;
  domainModified: boolean;
  nameUpdateAt: number;
  nameCanChange: boolean;
  emailDomains: string[];
  uin: string;
  enterpriseSize: string;
  industryType: string;
  certifyMsg: string;
  certifyCompleteTime: string; // 企业认证成功时间
}

export interface IBrands {
  position: LOGIN_POSITIONS;
  backgroundType: BACKGROUND_TYPES;
  imageUrl: string;
  fillingType: FILLING_TYPES;
  color: string;
  customCssEnabled: boolean;
  css: string;
  template: string;
  id?: string;
}

export type TCaptchaOption =
  | { ticket: string; randStr: string }
  | { sessionId: string; sig: string; token: string };
export type TCaptchaOptions = {
  appId: string;
  cloudType: string;
  appKey: string;
  scene: string;
};

export enum IDENTITY_TYPE {
  OIDC = 'OIDC_V0',
  SAML = 'SAML2_V1',
  SAML_LEGACY = 'SAML2_V0',
  WEWORK = 'WEWORK_V1',
  LARK = 'FEISHU_V0',
  AD = 'AD_V0',
  DINGTALK = 'DINGTALK_V0',
  CAS = 'CAS_V0',
  WEWORK_V0 = 'WEWORK_V0',
  OAUTH2 = 'OAUTH2_V0',
  PASSWORD = 'PASSWORD_V0', // 用户名密码
  JWT = 'JWT_V0',
}

export interface IResetPasswordUrlParams {
  reset_token: string;
}
